import moment from 'moment'
import * as _ from 'lodash'

export function getMonths (start, end) {
  var startDate = moment(start)
  var endDate = moment(end)
  var iterationDate = startDate.clone().add(-1, 'month')
  var resultArr=[]
  while(+(iterationDate.add(1, 'month'))<+endDate.endOf('month')) resultArr.push(iterationDate.format('MMM YY'))
  return resultArr
}

export function getTabTotals (data) {

  //const s = data.map(item => (Number(item.c_sale) * Number(quant)).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)

  if (data && data.length) {

    const c = data.map(item => (Number(item.b_cost) * Number(item.d_quantity))).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
    const s = data.map(item => (Number(item.c_sale) * Number(item.d_quantity))).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
    return {
      cost: c,
      sale: s
    }
  }
}

export function get1TabTotal (data) {
  if (data) {
    return {
      cost: data.map((doc, i) => { return (Number(doc.b_cost) * Number(doc.d_quantity ? doc.d_quantity : 0))}).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2),
      sale: data.map((doc, i) => { return (Number(doc.c_sale) * Number(doc.d_quantity ? doc.d_quantity : 0))}).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
    }
  }
}

export function getTotals (data) {
  if (data) {
  const allArss = data.map((item, index) => {
    if (item) {
      return item.map((doc, i) => {
        //console.log(doc)
        return Number(doc.amount)
      })
    }
  })
  return [].concat.apply([], allArss).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
  }
}

const tasksFromDataGoal = (data, value, key) => {

  //console.log((data, value, key))
  // const obj = Array.prototype.concat.apply([], Object.values(data).map(item => {
  //   if (item[value]) {
  //     return { label: item.label, amount: item[value]}
  //   } else {
  //     return { label: item.label, amount: 0}
  //   }
  // }))
  // return obj
}

export function re_order(data, get, paid) {
  // console.log(data)
  // console.log(get)
  if (data) {
    return Object.keys(data).map((key) => {
      if (data[key]) {
        return Object.values(data[key]).map(item => {
          //let wanted = item['zz_wanted']


          return {label: item['a_label'], amount: (Number(item[get] * item.d_quantity)), original: Number(item[get]), quantity: item.d_quantity, key: key}

          //if (item['zz_wanted'] != true || item['zz_wanted'] != false) wanted = true
          // if (paid) {
          //   if (!item.f_paid) {
          //     return {label: item['a_label'], amount: item[get], wanted: wanted, key: key}
          //   } else {
          //     return {label: item['a_label'], amount: 0, wanted: wanted, key: key}
          //   }
          // } else {
          //   return {label: item['a_label'], amount: item[get], wanted: wanted, key: key}
          // }
        })
      }
    })
  }
}


export function nextLetter(s){
    return s.replace(/([a-zA-Z])[^a-zA-Z]*$/, function(a){
        var c= a.charCodeAt(0);
        switch(c){
            case 90: return 'A';
            case 122: return 'a';
            default: return String.fromCharCode(++c)
        }
    })
}

export function emptyArrCleaner(obj, removeTypes) {

    var key;
    for (key in obj) {
        if (obj[key] === "" || obj[key] === undefined) {
            obj[key] = []
        }
    }
    return obj;
}

export function objCleaner(obj, removeTypes) {
    var defaultRemoveTypes = [null, 'undefined', false, '', [], {}];
    var key;

    function allowEmptyObject() {
        var i;
        for (i = 0; i < removeTypes.length; i++) {
            if (removeTypes[i] instanceof Object && Object.keys(removeTypes[i]).length === 0) {
                return false;
            }
        }

        return true;
    }

    function allowEmptyArray() {
        var i;
        for (i = 0; i < removeTypes.length; i++) {
            if (Array.isArray(removeTypes[i]) && removeTypes[i].length === 0) {
                return false;
            }
        }

        return true;
    }

    if (!(obj instanceof Object || Array.isArray(obj))) {
        throw new Error('Argument must be an object or Array');
    }

    if (typeof removeTypes === 'undefined') {
        removeTypes = defaultRemoveTypes;
    }

    for (key in obj) {
        if (typeof obj[key] === 'object') {
            if (obj[key] && Object.keys(obj[key]).length) {
                obj[key] = objCleaner(obj[key], removeTypes);
            } else {
                obj[key] = allowEmptyObject() ? obj[key] : null;
            }
        }

        if (Array.isArray(obj[key])) {
            if (obj[key] && obj[key].length) {
                obj[key] = objCleaner(obj[key], removeTypes);
            } else {
                obj[key] = allowEmptyArray() ? obj[key] : null;
            }
        }

        if (obj instanceof Object && obj.hasOwnProperty(key)) {
            removeTypes.forEach(function (typeVal) {
                if (typeof obj[key] === typeVal || obj[key] === typeVal) {
                    //delete obj[key];
                    return obj[key] = ''
                }
            });
        }

        if (Array.isArray(obj) && obj.length) {
            removeTypes.forEach(function (typeVal, index) {
                if (typeof obj[key] === typeVal || obj[key] === typeVal) {
                    obj.splice(key, 1);
                }
            });
        }
    }

    return obj;
}


export function share(url, title, image) {
    alert("sadfasd");
    FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
            object: {
                'og:url': url,
                'og:title': title,
                'og:description': "The Best Music is Shared - https://audiounderground.co",
                'og:image': image
            }
        })
    }, function(response){

    });
}

export function toggleBodyClass(className) {
  //jQuery("body").toggleClass(className);
}

export function removeBodyClass(className) {
    //jQuery("body").removeClass(className);
}

export function addBodyClass(className) {
    //jQuery("body").addClass(className);
}

export function setBodyClass(className) {
    document.body.className = className;
}

export function goToFacebookPage(facebookId, trackId) {
    if (facebookId) {
        alert(facebookId);
        var trackId = window.location.pathname.split("/")[3];
        if (trackId) {
            this.context.router.push("/page/" + facebookId + "/" + trackId);
        } else {
            this.context.router.push("/page/" + facebookId);
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/helpers.js